import React from "react";
import SectionCard from "./SectionCard";
import { Input } from "./Fields";

export default function ContactSocialSection({ form, onChange }) {
  return (
    <SectionCard
      title="Contact et réseaux sociaux"
      description="Coordonnées affichées sur le site public."
    >
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Input
          label="Email de contact"
          name="email_contact"
          value={form.email_contact}
          onChange={onChange}
          placeholder="contact@mairie.fr"
        />

        <Input
          label="Téléphone"
          name="telephone_contact"
          value={form.telephone_contact}
          onChange={onChange}
          placeholder="05 00 00 00 00"
        />

        <Input
          label="Facebook"
          name="link_facebook"
          value={form.link_facebook}
          onChange={onChange}
          placeholder="https://facebook.com/..."
        />

        <Input
          label="Instagram"
          name="link_instagram"
          value={form.link_instagram}
          onChange={onChange}
          placeholder="https://instagram.com/..."
        />

        <Input
          label="LinkedIn"
          name="link_linkedin"
          value={form.link_linkedin}
          onChange={onChange}
          placeholder="https://linkedin.com/..."
        />

        <Input
          label="YouTube"
          name="link_youtube"
          value={form.link_youtube}
          onChange={onChange}
          placeholder="https://youtube.com/..."
        />
      </div>
    </SectionCard>
  );
}